import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const ActualizarMovimiento = ()  => {
    const api = useApi();

    const mutate = async (params) => {
        const data  = await api.put(`/administracion-inventario/carga-descarga?printerId=${params.printerId}&printTag=${params.printTag}`, params.body, {
            dataType: "json",
            hasFormData: false,
            hasCustomUrl: false,
        });
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        actualizarMovimientoMutation: mutation.mutate,
    };
}